<template>
  <div class="flex" style="align-items: center;">
    <span v-if="!total" class="mr-1 flex" style="width: 95px;">
      Total {{ page.tot }}
      <s-tooltip
        class="ml-1 question-tip"
        :transfer="true"
        content="Total pages and total numbers are both estimated values because API Offer's status changes very frequently."
        placement="bottom"
      >
        <s-icon icon="question"></s-icon>
      </s-tooltip>
    </span>
    <s-pagination
      :count="page.tot"
      :cur="page.cur"
      :cb="change"
      :total="page.last_page || Math.ceil(page.tot / page.per)"
      :show-elevator = "showElevator"
      :show-total="total"
    ></s-pagination>
  </div>
</template>
<script>
export default {
  name: 'Pagination',
  props: {
    page: {
      type: Object,
      default() {
        return {
        }
      },
    },
    showElevator:{
      type:Boolean,
      default() {
        return true
      },
    },
    change: Function,
    total: {
      type: Boolean,
      default() {
        return true
      },
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.per-page
  line-height:30px;
</style>
